import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Theme/Common'

export const FeedContainerStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
  position: 'relative',
  padding: `${spacing.smx1} ${spacing.md} ${spacing.md}`,
  minHeight: '100dvh',
})
